export default {
	firestorePath: "participantAvailability",
	firestoreRefType: "collection",
	moduleName: "participantAvailability",
	statePropName: "data",
	namespaced: true,
	serverChange: {
	},
	state: {},
	getters: {
	},
	mutations: {},
	actions: {},
};
